import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/app/services/app-config.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  public cardnumber:string='';
  public expdate:string='';
  public cvv:string='';
  public isLoading:boolean = false;

  private canPop:boolean = false;
  
  constructor
  (
    private initializationservice:InitializationService, 
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private appconfigservice: AppConfigService,
    private customerservice : CustomerService,
    public alertDialog: MatDialog,
    private currentorderservice:CurrentOrderService,
    private router:Router,
    private localeservice:LocaleService
  ) { }

  ngOnInit(): void
  {
    // var appname = String(this.route.snapshot.paramMap.get('appname'));

    // if(!this.initializationservice.checkApp(appname))
    // {
    //   this.initializationservice.reloadApp(appname);

    //   return;
    // }
  }

  canReturn()
  { 
    if(this.canPop === true)
      return true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;

    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, 
        {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        resolve(result);
      });
    });
  }

  back()
  {
    this.navigationservice.back();
  }

  async save()
  {
    // if(!this.checkData())
    // {
    //   this.alertDialog.open(AlertDialogComponent, 
    //   {
    //     height: 'fit-content',
    //     width: 'fit-content',
    //     data: 
    //     { 
    //       title:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Title"), 
    //       detail:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Detail"), 
    //       accept:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Accept") 
    //     }
    //   });
    // }
    // else
    // {
    //   this.isLoading = true;

    //   let result = await this.customerservice.saveCustomerData();

    //   if(result !== true)
    //   {
    //     this.alertDialog.open(AlertDialogComponent, 
    //     {
    //       height: 'fit-content',
    //       width: 'fit-content',
    //       data: 
    //       { 
    //         title: this.localeservice.instantTranslation("Dialogs.Alert.ProfileSaveError.Title"),
    //         detail:this.localeservice.instantTranslation("Dialogs.Alert.ProfileSaveError.Detail"), 
    //         accept:this.localeservice.instantTranslation("Dialogs.Alert.ProfileSaveError.Accept") 
    //       }
    //     });
    //   }
    //   else
    //   {
    //     this.canPop = true;

    //     var afterto = String(this.route.snapshot.queryParamMap.get('afterto'));

    //     if(afterto === 'return')
    //       this.back();

    //     if(afterto === 'finishorder')
    //     {
    //       var appname = String(this.route.snapshot.paramMap.get('appname'));

    //       var orderType = this.currentorderservice.getOrderType();
      
    //       switch (orderType) 
    //       {
    //         case 0:
    //           this.router.navigateByUrl('/' + appname + '/paycard', { replaceUrl:true });
    //           break;
    //         case 1:
    //           this.router.navigateByUrl('/' + appname + '/orderbasedata', { replaceUrl:true });
    //           break;
    //         case 2:
    //           this.router.navigateByUrl('/' + appname + '/addresssearch?afterto=orderbasedata', { replaceUrl:true });
    //           break;
    //         case 3:
    //           this.router.navigateByUrl('/' + appname + '/orderbasedata', { replaceUrl:true });
    //           break;
    //         case 4:
    //           this.router.navigateByUrl('/' + appname + '/cardescription', { replaceUrl:true });
    //           break;
    //         default:
    //           break;
    //       }
    //     }
    //   }

    //   this.isLoading = false;
    // }
  }

  checkData()
  {
    return !(this.cardnumber.length === 0 || this.expdate.length === 0 || this.cvv.length === 0);
  }
}
